// utils/birthdayTemplates.js
// ← pas d'import useTranslation ici

export const getBirthdayTemplates = (t) => [
  { id: 'festif',        label: `🎉 ${t('birthday_card.festif')}` },
  { id: 'elegant',       label: `✨ ${t('birthday_card.elegant')}` },
  { id: 'floral',        label: `🌸 ${t('birthday_card.floral')}` },
  { id: 'tropical',      label: `🌴 ${t('birthday_card.tropical')}` },
  { id: 'minimaliste',   label: `🤍 ${t('birthday_card.minimaliste')}` },
  { id: 'algorithmique', label: `🎲 ${t('birthday_card.surprise')}` },
];
// Générateur pseudo-aléatoire seedé (même seed = même carte)
const seededRandom = (seed) => {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
};

const generateAlgorithmicSVG = (recipientName, message, t) => {
   // ← seed 100% aléatoire à chaque appel
  const seed = Math.floor(Math.random() * 2147483647);
  const rand = seededRandom(seed);

  // Palette aléatoire parmi plusieurs combinaisons
  const palettes = [
    { bg1: '#1a1a2e', bg2: '#16213e', accent1: '#e94560', accent2: '#f5a623', text: '#ffffff' },
    { bg1: '#0f3460', bg2: '#533483', accent1: '#e94560', accent2: '#f5a623', text: '#ffffff' },
    { bg1: '#2d6a4f', bg2: '#1b4332', accent1: '#95d5b2', accent2: '#ffd166', text: '#ffffff' },
    { bg1: '#f72585', bg2: '#7209b7', accent1: '#4cc9f0', accent2: '#f8961e', text: '#ffffff' },
    { bg1: '#ff6b35', bg2: '#f7931e', accent1: '#fff275', accent2: '#ff1654', text: '#ffffff' },
    { bg1: '#212529', bg2: '#343a40', accent1: '#f8f9fa', accent2: '#ffd60a', text: '#ffffff' },
  ];
  const palette = palettes[Math.floor(rand() * palettes.length)];

  // Générer confettis (cercles, carrés, triangles, losanges)
  const shapes = [];
  for (let i = 0; i < 30; i++) {
    const x = rand() * 600;
    const y = rand() * 400;
    const size = 4 + rand() * 14;
    const color = rand() > 0.5 ? palette.accent1 : palette.accent2;
    const opacity = 0.4 + rand() * 0.6;
    const type = Math.floor(rand() * 4);

    if (type === 0) {
      // Cercle
      shapes.push(`<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${(size/2).toFixed(1)}" fill="${color}" opacity="${opacity.toFixed(2)}"/>`);
    } else if (type === 1) {
      // Carré rotaté
      const rot = rand() * 45;
      shapes.push(`<rect x="${(x - size/2).toFixed(1)}" y="${(y - size/2).toFixed(1)}" width="${size.toFixed(1)}" height="${size.toFixed(1)}" fill="${color}" opacity="${opacity.toFixed(2)}" transform="rotate(${rot.toFixed(1)} ${x.toFixed(1)} ${y.toFixed(1)})"/>`);
    } else if (type === 2) {
      // Triangle
      const h = size * 0.866;
      shapes.push(`<polygon points="${x.toFixed(1)},${(y-h/2).toFixed(1)} ${(x+size/2).toFixed(1)},${(y+h/2).toFixed(1)} ${(x-size/2).toFixed(1)},${(y+h/2).toFixed(1)}" fill="${color}" opacity="${opacity.toFixed(2)}"/>`);
    } else {
      // Losange
      shapes.push(`<polygon points="${x.toFixed(1)},${(y-size/2).toFixed(1)} ${(x+size/2).toFixed(1)},${y.toFixed(1)} ${x.toFixed(1)},${(y+size/2).toFixed(1)} ${(x-size/2).toFixed(1)},${y.toFixed(1)}" fill="${color}" opacity="${opacity.toFixed(2)}"/>`);
    }
  }

  // Générer étoiles
  const stars = [];
  for (let i = 0; i < 12; i++) {
    const x = rand() * 600;
    const y = rand() * 400;
    const r1 = 3 + rand() * 8;
    const r2 = r1 * 0.4;
    const points = 5;
    const color = rand() > 0.5 ? palette.accent1 : palette.accent2;
    const opacity = 0.5 + rand() * 0.5;

    let starPoints = '';
    for (let j = 0; j < points * 2; j++) {
      const angle = (j * Math.PI) / points - Math.PI / 2;
      const r = j % 2 === 0 ? r1 : r2;
      const px = (x + r * Math.cos(angle)).toFixed(1);
      const py = (y + r * Math.sin(angle)).toFixed(1);
      starPoints += `${px},${py} `;
    }
    stars.push(`<polygon points="${starPoints.trim()}" fill="${color}" opacity="${opacity.toFixed(2)}"/>`);
  }

  // Motifs floraux (cercles concentriques)
  const florals = [];
  for (let i = 0; i < 5; i++) {
    const x = rand() * 600;
    const y = rand() * 400;
    const baseR = 8 + rand() * 15;
    const color = rand() > 0.5 ? palette.accent1 : palette.accent2;
    for (let j = 3; j >= 1; j--) {
      florals.push(`<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${(baseR * j / 3).toFixed(1)}" fill="none" stroke="${color}" stroke-width="1" opacity="${(0.2 + rand() * 0.3).toFixed(2)}"/>`);
    }
    // Pétales
    for (let j = 0; j < 6; j++) {
      const angle = (j * Math.PI * 2) / 6;
      const px = (x + baseR * Math.cos(angle)).toFixed(1);
      const py = (y + baseR * Math.sin(angle)).toFixed(1);
      florals.push(`<circle cx="${px}" cy="${py}" r="${(baseR * 0.35).toFixed(1)}" fill="${color}" opacity="${(0.15 + rand() * 0.2).toFixed(2)}"/>`);
    }
  }

  // Lignes décoratives aléatoires
  const lines = [];
  for (let i = 0; i < 8; i++) {
    const x1 = rand() * 600;
    const y1 = rand() * 400;
    const x2 = x1 + (rand() - 0.5) * 120;
    const y2 = y1 + (rand() - 0.5) * 120;
    const color = rand() > 0.5 ? palette.accent1 : palette.accent2;
    lines.push(`<line x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke="${color}" stroke-width="${(0.5 + rand() * 1.5).toFixed(1)}" opacity="${(0.2 + rand() * 0.4).toFixed(2)}"/>`);
  }

  const msg = message || `${t('birthday_card.happy_birthday')} ${recipientName} !`;
// 🧠 wrap texte
  const wrapText = (text, maxChars = 50) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach(word => {
      const testLine = line ? `${line} ${word}` : word;
      if (testLine.length > maxChars) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    });

    if (line) lines.push(line);
    return lines;
  };

  const messageLines = wrapText(msg, 70);

  return `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgAlgo" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:${palette.bg1}"/>
      <stop offset="100%" style="stop-color:${palette.bg2}"/>
    </linearGradient>
    <linearGradient id="textGrad" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:${palette.accent1}"/>
      <stop offset="100%" style="stop-color:${palette.accent2}"/>
    </linearGradient>
  </defs>

  <!-- Fond -->
  <rect width="600" height="400" fill="url(#bgAlgo)"/>

  <!-- Lignes -->
  ${lines.join('\n  ')}

  <!-- Motifs floraux -->
  ${florals.join('\n  ')}

  <!-- Confettis -->
  ${shapes.join('\n  ')}

  <!-- Étoiles -->
  ${stars.join('\n  ')}

  <!-- Bandeau central semi-transparent -->
  <rect x="0" y="140" width="600" height="130" fill="rgba(0,0,0,0.35)" rx="0"/>

  <!-- Texte -->
  <text x="300" y="185" text-anchor="middle" 
        font-family="Georgia, serif" font-size="18" 
        fill="${palette.accent1}" letter-spacing="4" opacity="0.9">
    ✦ ${t('birthday_card.happy_birthday_upper')} ✦
  </text>
  <text x="300" y="235" text-anchor="middle" 
        font-family="Georgia, serif" font-size="42" font-weight="bold" 
        fill="url(#textGrad)">
    ${recipientName}
  </text>
  <text x="300" y="310" text-anchor="middle" 
        font-family="Georgia, serif" font-size="16" 
        fill="${palette.text}" font-style="italic" opacity="0.85">
    ${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}

  </text>
</svg>`;
};
export const generateBirthdaySVG = (templateId, recipientName, message, t) => {
  const msg = message || `${t('birthday_card.happy_birthday')} ${recipientName} !`;
// ← ajouter en premier
  if (templateId === 'algorithmique') {
    return generateAlgorithmicSVG(recipientName, message, t);
  }
// 🧠 wrap texte
  const wrapText = (text, maxChars = 50) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach(word => {
      const testLine = line ? `${line} ${word}` : word;
      if (testLine.length > maxChars) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    });

    if (line) lines.push(line);
    return lines;
  };

  const messageLines = wrapText(msg, 70);

  const templates = {

    festif: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#FF6B6B"/>
      <stop offset="100%" style="stop-color:#FF8E53"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgGrad)"/>
  <!-- Confettis -->
  <circle cx="50" cy="60" r="8" fill="#FFF176" opacity="0.8"/>
  <circle cx="150" cy="30" r="6" fill="#B2FF59" opacity="0.8"/>
  <circle cx="250" cy="50" r="10" fill="#80D8FF" opacity="0.8"/>
  <circle cx="400" cy="25" r="7" fill="#FF80AB" opacity="0.8"/>
  <circle cx="520" cy="55" r="9" fill="#FFF176" opacity="0.8"/>
  <circle cx="570" cy="100" r="5" fill="#B2FF59" opacity="0.8"/>
  <circle cx="30" cy="200" r="7" fill="#FF80AB" opacity="0.8"/>
  <circle cx="580" cy="300" r="8" fill="#80D8FF" opacity="0.8"/>
  <circle cx="100" cy="370" r="6" fill="#FFF176" opacity="0.8"/>
  <circle cx="480" cy="380" r="9" fill="#B2FF59" opacity="0.8"/>
  <!-- Rectangles confettis -->
  <rect x="80" y="40" width="12" height="6" fill="#FFF176" opacity="0.7" transform="rotate(30 86 43)"/>
  <rect x="350" y="20" width="10" height="5" fill="#FF80AB" opacity="0.7" transform="rotate(-20 355 22)"/>
  <rect x="500" y="35" width="14" height="6" fill="#80D8FF" opacity="0.7" transform="rotate(45 507 38)"/>
  <rect x="20" y="150" width="10" height="5" fill="#B2FF59" opacity="0.7" transform="rotate(15 25 152)"/>
  <!-- Gâteau -->
  <rect x="255" y="170" width="90" height="60" rx="4" fill="#FFF9C4"/>
  <rect x="265" y="150" width="70" height="25" rx="4" fill="#FFCCBC"/>
  <rect x="255" y="195" width="90" height="8" fill="#FF80AB" opacity="0.6"/>
  <rect x="255" y="210" width="90" height="8" fill="#80D8FF" opacity="0.6"/>
  <!-- Bougies -->
  <rect x="278" y="138" width="6" height="16" fill="#FFF176"/>
  <rect x="297" y="138" width="6" height="16" fill="#FF80AB"/>
  <rect x="316" y="138" width="6" height="16" fill="#80D8FF"/>
  <ellipse cx="281" cy="137" rx="3" ry="5" fill="#FF6F00" opacity="0.9"/>
  <ellipse cx="300" cy="137" rx="3" ry="5" fill="#FF6F00" opacity="0.9"/>
  <ellipse cx="319" cy="137" rx="3" ry="5" fill="#FF6F00" opacity="0.9"/>
  <!-- Texte -->
  <text x="300" y="95" text-anchor="middle" font-family="Georgia, serif" font-size="36" font-weight="bold" fill="white">🎂 ${t('birthday_card.happy_birthday')}</text>
  <text x="300" y="135" text-anchor="middle" font-family="Georgia, serif" font-size="28" font-weight="bold" fill="#FFF176">${recipientName} !</text>
  <text x="300" y="290" text-anchor="middle" font-family="Georgia, serif" font-size="18" fill="white" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Étoiles -->
  <text x="60" y="320" font-size="24" fill="#FFF176">⭐</text>
  <text x="500" y="150" font-size="20" fill="#FFF176">⭐</text>
  <text x="520" y="340" font-size="28" fill="#FFF176">🎈</text>
  <text x="40" y="110" font-size="28" fill="#FFF176">🎈</text>
</svg>`,

    elegant: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgEleg" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#1a1a2e"/>
      <stop offset="100%" style="stop-color:#16213e"/>
    </linearGradient>
    <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:#BF953F"/>
      <stop offset="50%" style="stop-color:#FCF6BA"/>
      <stop offset="100%" style="stop-color:#BF953F"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgEleg)"/>
  <!-- Bordure dorée -->
  <rect x="20" y="20" width="560" height="360" fill="none" stroke="url(#goldGrad)" stroke-width="2"/>
  <rect x="28" y="28" width="544" height="344" fill="none" stroke="url(#goldGrad)" stroke-width="0.5"/>
  <!-- Ornements coins -->
  <circle cx="20" cy="20" r="5" fill="#FCF6BA"/>
  <circle cx="580" cy="20" r="5" fill="#FCF6BA"/>
  <circle cx="20" cy="380" r="5" fill="#FCF6BA"/>
  <circle cx="580" cy="380" r="5" fill="#FCF6BA"/>
  <!-- Lignes décoratives -->
  <line x1="80" y1="200" x2="220" y2="200" stroke="url(#goldGrad)" stroke-width="1"/>
  <line x1="380" y1="200" x2="520" y2="200" stroke="url(#goldGrad)" stroke-width="1"/>
  <circle cx="300" cy="200" r="4" fill="#FCF6BA"/>
  <!-- Étoiles décoratives -->
  <text x="120" y="120" text-anchor="middle" font-size="16" fill="#FCF6BA" opacity="0.4">✦</text>
  <text x="480" y="120" text-anchor="middle" font-size="16" fill="#FCF6BA" opacity="0.4">✦</text>
  <text x="120" y="300" text-anchor="middle" font-size="16" fill="#FCF6BA" opacity="0.4">✦</text>
  <text x="480" y="300" text-anchor="middle" font-size="16" fill="#FCF6BA" opacity="0.4">✦</text>
  <!-- Texte -->
  <text x="300" y="150" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#FCF6BA" letter-spacing="6">${t('birthday_card.happy_birthday_upper')}</text>
  <text x="300" y="195" text-anchor="middle" font-family="Georgia, serif" font-size="42" font-weight="bold" fill="url(#goldGrad)">${recipientName}</text>
  <text x="300" y="240" text-anchor="middle" font-family="Georgia, serif" font-size="14" fill="#FCF6BA" opacity="0.6">✦ ✦ ✦</text>
  <text x="300" y="280" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#FCF6BA" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
</svg>`,

    floral: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgFloral" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#FFF0F5"/>
      <stop offset="100%" style="stop-color:#FCE4EC"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgFloral)"/>
  <!-- Fleurs décoratives coins -->
  <text x="30" y="60" font-size="40">🌸</text>
  <text x="510" y="60" font-size="40">🌸</text>
  <text x="30" y="390" font-size="40">🌺</text>
  <text x="510" y="390" font-size="40">🌺</text>
  <!-- Fleurs milieu -->
  <text x="140" y="40" font-size="28">🌷</text>
  <text x="420" y="40" font-size="28">🌷</text>
  <text x="270" y="30" font-size="24">🌼</text>
  <!-- Tiges décoratives -->
  <path d="M 60 380 Q 100 300 80 200" stroke="#A5D6A7" stroke-width="2" fill="none"/>
  <path d="M 540 380 Q 500 300 520 200" stroke="#A5D6A7" stroke-width="2" fill="none"/>
  <!-- Bordure florale -->
  <rect x="15" y="15" width="570" height="370" fill="none" stroke="#F48FB1" stroke-width="1.5" stroke-dasharray="8,4"/>
  <!-- Texte -->
  <text x="300" y="150" text-anchor="middle" font-family="Georgia, serif" font-size="22" fill="#E91E8C">🌸 ${t('birthday_card.happy_birthday')} 🌸</text>
  <text x="300" y="205" text-anchor="middle" font-family="Georgia, serif" font-size="40" font-weight="bold" fill="#C2185B">${recipientName}</text>
  <text x="300" y="250" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#E91E8C" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Pétales bas -->
  <text x="220" y="330" font-size="20">🌸</text>
  <text x="270" y="345" font-size="16">🌷</text>
  <text x="310" y="330" font-size="20">🌺</text>
  <text x="355" y="345" font-size="16">🌸</text>
</svg>`,

    tropical: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgTrop" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#006064"/>
      <stop offset="100%" style="stop-color:#00838F"/>
    </linearGradient>
    <linearGradient id="sunGrad" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" style="stop-color:#FFD54F"/>
      <stop offset="100%" style="stop-color:#FF8F00"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgTrop)"/>
  <!-- Soleil -->
  <circle cx="300" cy="80" r="45" fill="url(#sunGrad)" opacity="0.9"/>
  <!-- Rayons soleil -->
  <line x1="300" y1="20" x2="300" y2="10" stroke="#FFD54F" stroke-width="3"/>
  <line x1="343" y1="37" x2="350" y2="28" stroke="#FFD54F" stroke-width="3"/>
  <line x1="360" y1="80" x2="370" y2="80" stroke="#FFD54F" stroke-width="3"/>
  <line x1="343" y1="123" x2="350" y2="132" stroke="#FFD54F" stroke-width="3"/>
  <line x1="257" y1="37" x2="250" y2="28" stroke="#FFD54F" stroke-width="3"/>
  <line x1="240" y1="80" x2="230" y2="80" stroke="#FFD54F" stroke-width="3"/>
  <line x1="257" y1="123" x2="250" y2="132" stroke="#FFD54F" stroke-width="3"/>
  <!-- Palmiers -->
  <text x="20" y="380" font-size="80">🌴</text>
  <text x="480" y="380" font-size="80">🌴</text>
  <!-- Vague -->
  <path d="M 0 320 Q 150 290 300 320 Q 450 350 600 320 L 600 400 L 0 400 Z" fill="#0097A7" opacity="0.5"/>
  <path d="M 0 350 Q 150 320 300 350 Q 450 380 600 350 L 600 400 L 0 400 Z" fill="#00BCD4" opacity="0.4"/>
  <!-- Éléments tropicaux -->
  <text x="80" y="200" font-size="28">🦜</text>
  <text x="470" y="200" font-size="28">🌺</text>
  <text x="270" y="380" font-size="24">🐚</text>
  <!-- Texte -->
  <text x="300" y="175" text-anchor="middle" font-family="Georgia, serif" font-size="22" fill="#FFF9C4">🌴  ${t('birthday_card.happy_birthday')} 🌴</text>
  <text x="300" y="225" text-anchor="middle" font-family="Georgia, serif" font-size="38" font-weight="bold" fill="#FFD54F">${recipientName}</text>
  <text x="300" y="265" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="white" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
</svg>`,

    minimaliste: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <rect width="600" height="400" fill="#FAFAFA"/>
  <!-- Ligne décorative simple -->
  <line x1="100" y1="180" x2="500" y2="180" stroke="#E0E0E0" stroke-width="1"/>
  <line x1="100" y1="240" x2="500" y2="240" stroke="#E0E0E0" stroke-width="1"/>
  <!-- Point central -->
  <circle cx="300" cy="100" r="30" fill="none" stroke="#333" stroke-width="1.5"/>
  <text x="300" y="110" text-anchor="middle" font-size="28">🕯️</text>
  <!-- Texte -->
  <text x="300" y="165" text-anchor="middle" font-family="Georgia, serif" font-size="13" fill="#999" letter-spacing="4">${t('birthday_card.happy_birthday_upper')}</text>
  <text x="300" y="222" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="#333">${recipientName}</text>
  <text x="300" y="265" text-anchor="middle" font-family="Georgia, serif" font-size="15" fill="#777" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Petits points décoratifs -->
  <circle cx="200" cy="210" r="2" fill="#CCC"/>
  <circle cx="300" cy="210" r="2" fill="#CCC"/>
  <circle cx="400" cy="210" r="2" fill="#CCC"/>
  <!-- Bordure subtile -->
  <rect x="40" y="40" width="520" height="320" fill="none" stroke="#F0F0F0" stroke-width="1"/>
</svg>`,

  };

  return templates[templateId] || templates['festif'];
};